export default __webpack_public_path__ + "static/media/circular-board.918b77b1.svg";